import React, { useState } from "react";

export default function TiffinServiceUI() {
  const [form, setForm] = useState({
    location: "",
    serviceType: "Tiffin",
    dishName: "",
  });

  const [requestForm, setRequestForm] = useState({
    name: "",
    address: "",
    dateTime: "",
  });

  const handleSearch = () => {
    // Add search logic here
    console.log("Searching with:", form);
  };

  const handleRequestSubmit = () => {
    // Add request submission logic here
    console.log("Request Submitted:", requestForm);
  };

  return (
    <div className="p-6 space-y-8 max-w-4xl mx-auto">
      {/* Search Section */}
      <div className="bg-lime-300 border p-4 rounded-xl shadow">
        
	<h1 class="mb-4 text-3xl font-extrabold text-gray-900 dark:text-white md:text-5xl lg:text-6xl text-center"><span class="text-transparent bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">Tiffin & Catering Service</span></h1>

      </div>

      <div className="border p-4 rounded-xl shadow">
        <h2 className="text-xl font-bold mb-4">Find Tiffin and Catering Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <select
            className="p-2 border rounded"
            value={form.location}
            onChange={(e) => setForm({ ...form, location: e.target.value })}
          >
            <option value="">Select Location</option>
            <option value="Ahmedabad">Wentworthville</option>
            <option value="Mumbai">Westmead</option>
          </select>

          <select
            className="p-2 border rounded"
            value={form.serviceType}
            onChange={(e) => setForm({ ...form, serviceType: e.target.value })}
          >
            <option value="Tiffin">Tiffin</option>
            <option value="Catering">Catering</option>
          </select>

          <input
            className="p-2 border rounded"
            type="text"
            placeholder="Dish Name"
            value={form.dishName}
            onChange={(e) => setForm({ ...form, dishName: e.target.value })}
          />
        </div>
        <button
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded"
          onClick={handleSearch}
        >
          Search
        </button>
      </div>

      {/* Results Section */}
      <div className="border p-4 rounded-xl shadow">
        <h2 className="text-xl font-bold mb-4">Search Results</h2>
        {[1, 2, 3].map((item) => (
          <div
            key={item}
            className="flex items-center border p-2 mb-2 rounded justify-between"
          >
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-gray-200" />
              <div>
                <p className="font-semibold">Dish / Menu Name</p>
                <p>Service Type</p>
                <p>Price</p>
                <p>Delivery Area</p>
              </div>
            </div>
            <button className="px-3 py-1 bg-green-600 text-white rounded">
              Request This Service
            </button>
          </div>
        ))}
      </div>

      {/* Request Form */}
      <div className="border p-4 rounded-xl shadow">
        <h2 className="text-xl font-bold mb-4">Request Service</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            className="p-2 border rounded"
            type="text"
            placeholder="Name"
            value={requestForm.name}
            onChange={(e) => setRequestForm({ ...requestForm, name: e.target.value })}
          />
          <input
            className="p-2 border rounded"
            type="text"
            placeholder="Delivery Address"
            value={requestForm.address}
            onChange={(e) => setRequestForm({ ...requestForm, address: e.target.value })}
          />
          <input
            className="p-2 border rounded"
            type="datetime-local"
            value={requestForm.dateTime}
            onChange={(e) => setRequestForm({ ...requestForm, dateTime: e.target.value })}
          />
        </div>
        <button
          className="mt-4 px-4 py-2 bg-purple-600 text-white rounded"
          onClick={handleRequestSubmit}
        >
          Submit Request
        </button>
      </div>

	{/* Footer */}
	<footer class="bg-white rounded-lg shadow-sm m-4 dark:bg-gray-800">
    		<div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
      			<span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2025 <a href="https://webgradients.com.au/" class="hover:underline">Web Gradients - Australia</a>. All Rights Reserved.
    			</span>
    		</div>
	</footer>
    </div>

  );
}
